import ErrorWrapper from './error-wrapper';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkOutlined from '@mui/icons-material/LinkOutlined';

export default function ErrorPage() {
  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader
          title={
            "An error has occurred when trying to access your domain's information."
          }
          subheader="The common occurrences of this are the following:"
        />
        <CardContent>
          <Stack gap={2}>
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography>
                1. The Provisioning API Access has been disabled on your domain.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="https://support.google.com/a/answer/60757?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>

            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography>
                2. Data access to gPanel needs to be granted.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="https://resources.promevo.com/knowledgebase/gpanel/getting-started/how-to-configure-gpanel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>

            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography>
                3. The application administrator is not currently a Google Apps
                admin, or has been suspended or deleted.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="https://support.google.com/a/answer/33325?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>

            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography>
                4. A Google error has occurred trying to access your domain's
                information.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="http://www.google.com/appsstatus#hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>

            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography>
                5. If you feel you have reached this page in error.
              </Typography>
              <IconButton
                size="small"
                component="a"
                href="http://resources.promevo.com/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkOutlined />
              </IconButton>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </ErrorWrapper>
  );
}
